export default __webpack_public_path__ + "static/media/00_welcome.f1fac2b4.mp3";